class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  isHeaderSearch() {
    return this.classList.contains('header__search');
  }

  getHeaderSection() {
    return this.closest('.section-header');
  }

  getHeaderSearchDetails() {
    const headerSection = this.getHeaderSection();
    if (!headerSection) return [];
    return Array.from(headerSection.querySelectorAll('details-modal.header__search details'));
  }

  getVisibleHeaderSearchDetails() {
    return this.getHeaderSearchDetails().find((details) => details.closest('details-modal')?.offsetParent !== null) || null;
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    const clickedDetails = event.target.closest('details') || this.detailsContainer;
    let activeDetails = clickedDetails;
    clickedDetails.setAttribute('open', true);

    if (this.isHeaderSearch()) {
      const headerSection = this.getHeaderSection();
      if (headerSection) {
        headerSection.classList.add('menu-open', 'shopify-section-header-sticky');
        headerSection.classList.remove('shopify-section-header-hidden');
      }
      document.body.classList.add('header-search-open');

      const visibleDetails = this.getVisibleHeaderSearchDetails();
      if (visibleDetails) {
        activeDetails = visibleDetails;
        if (visibleDetails !== clickedDetails) {
          clickedDetails.removeAttribute('open');
          visibleDetails.setAttribute('open', true);
        }
      }
    }

    document.body.addEventListener('click', this.onBodyClickEvent);
    this.usesSimpleBodyLock = this.isHeaderSearch() && window.matchMedia('(max-width: 989px)').matches;
    if (this.usesSimpleBodyLock) {
      document.body.classList.add('overflow-hidden');
    } else if (typeof window.lockBodyScroll === 'function') {
      window.lockBodyScroll();
    } else {
      document.body.classList.add('overflow-hidden');
    }

    trapFocus(
      activeDetails.querySelector('[tabindex="-1"]'),
      activeDetails.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);

    if (this.isHeaderSearch()) {
      this.getHeaderSearchDetails().forEach((details) => details.removeAttribute('open'));
    } else {
      this.detailsContainer.removeAttribute('open');
    }

    if (this.isHeaderSearch()) {
      const headerSection = this.getHeaderSection();
      if (headerSection) headerSection.classList.remove('menu-open');

      const hasOpenHeaderSearch = !!document.querySelector('details-modal.header__search details[open]');
      if (!hasOpenHeaderSearch) document.body.classList.remove('header-search-open');
    }

    document.body.removeEventListener('click', this.onBodyClickEvent);
    if (this.usesSimpleBodyLock) {
      document.body.classList.remove('overflow-hidden');
    } else if (typeof window.unlockBodyScroll === 'function') {
      window.unlockBodyScroll();
    } else {
      document.body.classList.remove('overflow-hidden');
    }
    this.usesSimpleBodyLock = false;
  }
}

customElements.define('details-modal', DetailsModal);
